import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || categories[0].slug);

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeSlug) || categories[0];
  const articles = getArticlesByCategory(activeSlug);

  return (
    <>
      {/* JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${currentCategory.name} - 黄网识别与防范指南`,
            description: currentCategory.description,
            url: `https://fangfanhuangwang.com/category/${currentCategory.slug}`,
            isPartOf: {
              '@type': 'WebSite',
              name: '黄网识别与防范指南',
            },
          }),
        }}
      />

      <main className="pt-24 pb-16 md:pb-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          {/* Breadcrumb */}
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: currentCategory.name },
              ]}
            />
          </div>

          {/* Category Header */}
          <div className="mb-10">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                <i className={`${currentCategory.icon} text-2xl`}></i>
              </div>
              <div>
                <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                  {currentCategory.name}
                </h1>
                <p className="text-foreground-500 mt-1">{currentCategory.description}</p>
              </div>
            </div>
          </div>

          {/* Category Tabs */}
          <div className="flex items-center gap-2 mb-10 overflow-x-auto pb-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600'
                }`}
              >
                <i className={`${cat.icon} mr-1.5`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {/* Article Grid */}
          {articles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
                <i className="ri-inbox-line text-2xl"></i>
              </div>
              <p className="text-foreground-500">该分类下暂无文章</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}